import { render, staticRenderFns } from "./countersoverview.vue?vue&type=template&id=35b40a12&scoped=true"
import script from "./countersoverview.vue?vue&type=script&lang=js"
export * from "./countersoverview.vue?vue&type=script&lang=js"
import style0 from "./countersoverview.vue?vue&type=style&index=0&id=35b40a12&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35b40a12",
  null
  
)

export default component.exports